<script lang="ts">
    import {Component, Prop, toNative, Vue} from 'vue-facing-decorator'
    import CityAutocomplete from '~/components/search/forms/CityAutocomplete.vue'

    @Component({mixins: [CityAutocomplete]})
    export class HotelAutocomplete extends Vue {
        @Prop() cityId
        @Prop() contentProviderId
        @Prop({default: false, type: Boolean}) isSortByName

        async searchHotels(val) {
            const rq = {
                pattern: val,
                contentProviderId: this.contentProviderId,
                limit: 10,
            }

            if (this.cityId) {
                rq.locationId = this.cityId
            } else if (this.countryId) {
                rq.locationId = this.countryId
            }
            const rs = await this.$api.suggestHotels.get(rq, this.cancelTokenSource.token)
            if (this.isSortByName) rs.hotels.sort((a, b) => a.name.localeCompare(b.name))

            return rs.hotels.map(hotel => {
                const location = hotel.location
                delete hotel.location
                return Object.assign(hotel, location, {parentName: location.countryName, type: 'hotel'})
            })
        }

        async initSearch(val) {
            if ((this.entries.length > 0 && this.entries.indexOf(val) !== -1) || !val) return
            this.loading = true
            if (this.cancelTokenSource) this.cancelTokenSource.cancel('Operation canceled by the user.')
            this.cancelTokenSource = this.$axios.CancelToken.source()

            try {
                this.entries = await this.searchHotels(val)
            } catch (e) {
                /* empty */
            } finally {
                this.loading = false
            }
        }

        icon(type) {
            switch (type) {
                case 'hotel':
                    return this.hotelIcon
                default:
                    return this.locationIcon
            }
        }

        itemLabel(entry) {
            return `${entry.name}, ${entry.cityName}, ${entry.countryName}`
        }

        get hotelIcon() {
            return 'mdi-office-building'
        }
    }

    export default {...toNative(HotelAutocomplete), ssrRender: CityAutocomplete.ssrRender}
</script>

<style scoped lang="scss">
    :deep(.v-dialog) {
        overflow-y: hidden;
    }
    :deep(.v-label) {
        font-size: inherit;
    }

    :deep(.v-autocomplete__selection) {
        line-height: unset !important;
        height: unset !important;
        display: flex;
        align-items: start;
    }
</style>
